import React from 'react';
import PageHero from './componenets/PageHero';
import Reveal from './componenets/Reveal';

const images = [
  ['HomeSlider_1.jpeg', 'Garden of Peace property landscape'],
  ['HomeSlider_2.jpeg', 'Community members visiting the property'],
  ['HomeSlider_3.jpeg', 'Garden of Peace community gathering'],
  ['HomeSlider_4.jpg', 'Community members at the cemetery property'],
  ['HomeSlider_5.jpg', 'Garden of Peace team visit'],
  ['HomeSlider_6.jpg', 'Community gathering at the property'],
  ['HomeSlider_7.jpg', 'Reviewing plans for the Garden of Peace property'],
  ['HomeSlider_8.jpg', 'Garden of Peace team members'],
  ['HomeSlider_9.jpg', 'Prayer at the Garden of Peace property'],
  ['HomeSlider_10.jpg', 'View across the Garden of Peace landscape'],
  ['HomeSlider11.jpg', 'Garden of Peace property'],
  ['HomeSlider12.jpg', 'Shaded area at the property'],
  ['Gallery_1.jpg', 'Garden of Peace community activity'],
  ['Gallery_2.jpg', 'Garden of Peace project progress'],
  ['Gallery_3.jpg', 'Garden of Peace community members'],
];

export const Gallery = () => (
  <div className="site-page">
    <PageHero eyebrow="Garden of Peace" title="Photo Gallery" description="Photos of the cemetery property, project progress, and community activities." image="/images/Gallery_4.jpg" compact />
    <section className="site-section"><div className="site-container gallery-grid">
      {images.map(([image, alt], index) => <Reveal className={'gallery-item gallery-item--' + ((index % 5) + 1)} delay={(index % 3) * 70} key={image}><img src={'/images/' + image} alt={alt} loading="lazy" /></Reveal>)}
    </div></section>
  </div>
);
